import { Card, Input, Select, message } from "antd";
import { useState } from "react";
import { ContactTable } from "../components/ContactTable";
import { useContacts, useContactActions } from "../../../../hooks/useContact";

const { Option } = Select;

export function ContactsPage() {
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: "",
    status: "",
    category: "",
  });

  const { data: contacts, pagination, isLoading } = useContacts(filter);
  const { updateContactStatus, deleteContact } = useContactActions();

  const handleFilterChange = (key, value) => {
    setFilter({
      ...filter,
      [key]: value,
      page: 1, // Reset to first page when filter changes
    });
  };

  const handleTableChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
    });
  };

  const handleStatusChange = async (contactId, data) => {
    try {
      await updateContactStatus.mutateAsync({ id: contactId, data });
      message.success("Cập nhật trạng thái thành công!");
    } catch (error) {
      message.error("Cập nhật trạng thái thất bại!");
    }
  };

  const handleDelete = async (contactId) => {
    try {
      await deleteContact.mutateAsync(contactId);
      message.success("Xóa tin nhắn thành công!");
    } catch (error) {
      message.error("Xóa tin nhắn thất bại!");
    }
  };

  const contactCategories = [
    { value: "", label: "Tất cả loại" },
    { value: "general", label: "Liên hệ chung" },
    { value: "retreat", label: "Thông tin khóa tu" },
    { value: "donation", label: "Quyên góp" },
    { value: "volunteer", label: "Tình nguyện" },
    { value: "media", label: "Truyền thông" },
    { value: "other", label: "Khác" },
  ];

  const statusOptions = [
    { value: "", label: "Tất cả trạng thái" },
    { value: "pending", label: "Chờ xử lý" },
    { value: "replied", label: "Đã trả lời" },
    { value: "closed", label: "Đã đóng" },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>Quản lý liên hệ</h2>
          <p style={{ margin: "8px 0 0 0", color: "#666" }}>
            Tổng số: {pagination.total} tin nhắn
          </p>
        </div>
      </div>

      {/* Filters */}
      <Card style={{ marginBottom: 24 }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: 16,
          }}
        >
          <div>
            <label
              style={{ display: "block", marginBottom: 8, fontWeight: 500 }}
            >
              Tìm kiếm
            </label>
            <Input
              placeholder="Tên, email, tiêu đề..."
              value={filter.search}
              onChange={(e) => handleFilterChange("search", e.target.value)}
              allowClear
            />
          </div>

          <div>
            <label
              style={{ display: "block", marginBottom: 8, fontWeight: 500 }}
            >
              Loại liên hệ
            </label>
            <Select
              value={filter.category}
              onChange={(value) => handleFilterChange("category", value)}
              style={{ width: "100%" }}
            >
              {contactCategories.map((category) => (
                <Option key={category.value} value={category.value}>
                  {category.label}
                </Option>
              ))}
            </Select>
          </div>

          <div>
            <label
              style={{ display: "block", marginBottom: 8, fontWeight: 500 }}
            >
              Trạng thái
            </label>
            <Select
              value={filter.status}
              onChange={(value) => handleFilterChange("status", value)}
              style={{ width: "100%" }}
            >
              {statusOptions.map((status) => (
                <Option key={status.value} value={status.value}>
                  {status.label}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>

      {/* Contact Table */}
      <Card>
        <ContactTable
          contacts={contacts}
          pagination={pagination}
          isLoading={isLoading}
          onTableChange={handleTableChange}
          onStatusChange={handleStatusChange}
          onDelete={handleDelete}
        />
      </Card>
    </div>
  );
}
